function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import { StyledIcon } from '../StyledIcon';
export var Go = function Go(props) {
  return React.createElement(StyledIcon, _extends({
    viewBox: "0 0 250 140",
    a11yTitle: "Go"
  }, props), React.createElement("style", {
    type: "text/css"
  }), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
    "class": "sdk-icon",
    d: "M19.69,51.72c-0.48,0-0.6-0.24-0.36-0.6l2.54-3.26c0.24-0.36,0.85-0.6,1.33-0.6h43.12 c0.48,0,0.6,0.36,0.36,0.72l-2.05,3.14c-0.24,0.36-0.85,0.72-1.21,0.72L19.69,51.72z"
  })))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
    "class": "sdk-icon",
    d: "M1.46,62.83c-0.48,0-0.6-0.24-0.36-0.6l2.54-3.26c0.24-0.36,0.85-0.6,1.33-0.6h55.07 c0.48,0,0.72,0.36,0.6,0.72l-0.97,2.9c-0.12,0.48-0.6,0.72-1.09,0.72L1.46,62.83z"
  })))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
    "class": "sdk-icon",
    d: "M30.68,73.95c-0.48,0-0.6-0.36-0.36-0.72l1.69-3.02c0.24-0.36,0.72-0.72,1.21-0.72h24.15 c0.48,0,0.72,0.36,0.72,0.85l-0.24,2.9c0,0.48-0.48,0.85-0.85,0.85L30.68,73.95z"
  })))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
    "class": "sdk-icon",
    d: "M156.05,49.55c-7.61,1.93-12.8,3.38-20.29,5.31c-1.81,0.48-1.93,0.6-3.5-1.21 c-1.81-2.05-3.14-3.38-5.68-4.59c-7.61-3.74-14.98-2.66-21.86,1.81c-8.21,5.31-12.44,13.16-12.32,22.95 c0.12,9.66,6.76,17.63,16.3,18.96c8.21,1.09,15.1-1.81,20.53-7.97c1.09-1.33,2.05-2.78,3.26-4.47c-4.35,0-9.78,0-23.31,0 c-2.54,0-3.14-1.57-2.29-3.62c1.57-3.74,4.47-10.02,6.16-13.16c0.36-0.72,1.21-1.93,3.02-1.93c6.16,0,28.86,0,43.96,0 c-0.24,3.26-0.24,6.52-0.72,9.78c-1.33,8.7-4.59,16.67-9.9,23.67c-8.7,11.47-20.05,18.6-34.42,20.53 c-11.84,1.57-22.83-0.72-32.49-7.97c-8.94-6.76-14.01-15.7-15.34-26.81c-1.57-13.16,2.29-25,10.27-35.39 C86,34.21,97.35,27.09,111.24,24.55c11.35-2.05,22.22-0.72,32,5.92c6.4,4.23,10.99,10.02,14.01,17.03 C157.98,48.58,157.49,49.19,156.05,49.55z"
  })), React.createElement("g", null, React.createElement("path", {
    "class": "sdk-icon",
    d: "M196.02,116.34c-10.99-0.24-21.01-3.38-29.47-10.63c-7.13-6.16-11.59-14.01-13.04-23.31 c-2.17-13.65,1.57-25.72,9.78-36.47c8.82-11.59,19.44-17.63,33.82-20.17c12.32-2.17,23.91-0.97,34.42,6.16 c9.54,6.52,15.46,15.34,17.03,26.93c2.05,16.3-2.66,29.59-13.89,40.94c-7.97,8.09-17.75,13.16-28.99,15.46 C202.42,115.85,199.16,115.97,196.02,116.34z M224.76,67.54c-0.12-1.57-0.12-2.78-0.36-3.99 c-2.17-11.96-13.16-18.72-24.64-16.06c-11.23,2.54-18.48,9.66-21.14,21.01c-2.17,9.42,2.42,18.96,11.11,22.83 c6.64,2.9,13.28,2.54,19.69-0.72C218.97,85.66,224.16,77.93,224.76,67.54z"
  })))))));
};